import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import { ROUTE_PATHS, API_BASE_URL } from '../config/constants';
import { search } from '../services/api';
import '../assets/css/styles.css';

const Header = () => {
  const { isAdmin, logout } = useAdminAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    const currentPage = location.pathname;
    if (searchQuery) {
      navigate(`${currentPage}?search=${searchQuery}`);
    }
  };

  const handleLogout = () => {
    alert('Has salido de la edición');
    logout();
  };

  useEffect(() => {
    if (!searchQuery) {
      setSearchResults([]);
      return;
    }

    const performSearch = async () => {
      try {
        const results = await search(searchQuery);
        setSearchResults(results);
      } catch (error) {
        setSearchResults([]);
      }
    };

    const debounceTimer = setTimeout(performSearch, 300);
    return () => clearTimeout(debounceTimer);
  }, [searchQuery]);

  return (
    <header>
      <nav className="navbar navbar-expand-lg navbar-light">
        <Link className="navbar-brand" to={ROUTE_PATHS.HOME}>
          <img
            src={`${API_BASE_URL}/public/uploads/images/logo.png`}
            width="180px"
            height="auto"
            alt="Logo"
            loading="eager"
            fetchpriority="high"
          />
        </Link>
        <button
          className="navbar-toggler toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse collapsed" id="navbarNav">
          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <Link className="nav-link" to={ROUTE_PATHS.COURSES}>
                Cursos
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link ms-2" to={ROUTE_PATHS.ARTICLES}>
                Divulgación y Transferencia
              </Link>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown1"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Investigación
              </a>
              <ul className="dropdown-menu dropdown" aria-labelledby="navbarDropdown1">
                <li>
                  <Link className="dropdown-item" to={ROUTE_PATHS.TALKS}>
                    Congresos y Seminarios
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to={ROUTE_PATHS.PROJECTS}>
                    Proyectos
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to={ROUTE_PATHS.PUBLICATIONS}>
                    Publicaciones
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={ROUTE_PATHS.MEMBERS}>
                Integrantes
              </Link>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="mailto:ligaincom@us.es">
                Contacta
              </a>
            </li>
          </ul>

          <div className="d-flex ms-auto align-items-center">
            {isAdmin ? (
              <button
                className="btn logout-btn"
                style={{
                  backgroundColor: 'white',
                  border: '5px solid #005EC4',
                  borderRadius: '20px',
                  color: '#005EC4',
                  cursor: 'pointer',
                  padding: '10px',
                  textDecoration: 'none',
                }}
                onClick={handleLogout}
              >
                Logout
              </button>
            ) : (
              <Link
                className="nav-link"
                to={ROUTE_PATHS.ADMIN}
                style={{
                  fontWeight: 600,
                  color: '#005EC4',
                }}
              >
                Acceso admin
              </Link>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;

